import { Organization } from "../../types"

export const getOrgBrandsIDs = (org?: Organization) => {
  return (org?.brands ?? []).map(brand => brand.id).join(",")
}

export const getUserBrandId = (org: Organization, userId: string) =>
  org?.brands?.find(b => b.default_loid === userId)?.id
